export * from './skeleton-box.component';
export * from './skeleton-table.component';
export * from './skeleton-card.component';
export * from './skeleton-detail.component';
